export const defaultExcelLimit = 500
export const maxExcelLimit = 10000
